import { DataLayerManagerInterface } from './dataLayerManager/abstractDataLayerManager';
import { HomepageTrackingActions } from './types';
import { CommonEventOptions } from 'Common/appshell_types/trackingHelpers';

export const HomepageEventCategory = 'Homepage';

export enum BannerTrackingVariations {
    General,
    WestwingCollection,
    InteriorDesignService,
}

export default class HomepageTracker {
    private dataLayerManager: DataLayerManagerInterface;

    public constructor(dataLayerManager: DataLayerManagerInterface) {
        this.dataLayerManager = dataLayerManager;
    }

    public getBannerTrackingFn(action: BannerTrackingVariations, label: string) {
        const trackingActionText = [
            [BannerTrackingVariations.General, 'Homepage banners Click'],
            [BannerTrackingVariations.WestwingCollection, 'Westwing Collection banner Click'],
            [BannerTrackingVariations.InteriorDesignService, 'Interior Service banner Click'],
        ];

        const actionTxt = trackingActionText.filter(pair => pair[0] === action)[0][1];
        return () => this.trackBannerClick(label, actionTxt as string);
    }

    private trackBannerClick(label: string, actionTxt: string) {
        this.dataLayerManager.sendGenericEvent({
            category: HomepageEventCategory,
            action: actionTxt,
            label,
        });
    }

    public trackBannerImpression(label: string) {
        this.dataLayerManager.sendEvent('HomepageImpression', {
            category: HomepageEventCategory,
            action: 'Homepage banners Impression',
            label: label || '',
        });
    }

    public trackSliderImpression(label: string) {
        this.dataLayerManager.sendGenericEvent({
            category: HomepageEventCategory,
            action: 'Homepage sliders impression',
            label: label || '',
        });
    }

    public trackReferAFriendBannerImpression(label: string) {
        this.dataLayerManager.sendGenericEvent({
            category: HomepageEventCategory,
            action: 'Refer a friend banner impression',
            label,
        });
    }

    public trackReferAFriendBannerClick(label: string) {
        this.dataLayerManager.sendGenericEvent({
            category: HomepageEventCategory,
            action: 'Refer a friend banner click',
            label,
        });
    }

    public trackCategorySliderTrackingClick(label: string, i: number) {
        this.dataLayerManager.sendGenericEvent({
            category: HomepageEventCategory,
            action: 'Category slider click',
            label: `${label} ${i}`,
        });
    }

    public trackLooksSliderTrackingClick(label: string) {
        this.dataLayerManager.sendGenericEvent({
            category: HomepageEventCategory,
            action: 'Shop the Look slider click',
            label,
        });
    }

    public trackLooksSliderSeeAllTrackingClick() {
        this.dataLayerManager.sendGenericEvent({
            category: HomepageEventCategory,
            action: 'Shop the Look slider click',
            label: 'See all button at top',
        });
    }

    public trackUGCClick(label: string) {
        this.dataLayerManager.sendGenericEvent({
            category: HomepageEventCategory,
            action: 'User Generated Gallery Banner Click',
            label,
        });
    }

    public trackNewProductSliderClick() {
        this.dataLayerManager.sendGenericEvent({
            category: HomepageEventCategory,
            action: 'New products slider Click',
            label: 'Product item click',
        });
    }

    public trackBestSellerProductSliderClick() {
        this.dataLayerManager.sendGenericEvent({
            category: HomepageEventCategory,
            action: 'Best sellers slider click',
            label: 'Product item click',
        });
    }

    public trackNewProductsSeeAllLastTileClick() {
        this.dataLayerManager.sendGenericEvent({
            category: HomepageEventCategory,
            action: 'New products slider Click',
            label: 'See all item last tile',
        });
    }

    public trackNewProductsSeeAllTopBtnClick() {
        this.dataLayerManager.sendGenericEvent({
            category: HomepageEventCategory,
            action: 'New products slider Click',
            label: 'See all button at top',
        });
    }

    public trackCrossCategoryBubbleClick(options: CommonEventOptions): this {
        this.dataLayerManager.sendGenericEvent({
            category: HomepageEventCategory,
            ...options,
        });
        return this;
    }

    public trackSliderArrowComponentClick(label: string): this {
        this.dataLayerManager.sendGenericEvent({
            category: HomepageEventCategory,
            action: HomepageTrackingActions.SliderArrowComponentClick,
            label,
        });
        return this;
    }

    public trackPromotionalInfusionClick(label: string): this {
        this.dataLayerManager.sendGenericEvent({
            category: HomepageEventCategory,
            action: HomepageTrackingActions.PromotionalInfusionClick,
            label,
        });
        return this;
    }
}
